module.exports = {"young":[18,35],"adult":[36,55],"old":[56,99]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/age-groups.json
// module id = 354
// module chunks = 0